import React from "react";
import {
    Drawer,
    IconButton,
    Tabs,
    Tab,
    Avatar,
    Divider,
    Button,
    Box,
} from "@mui/material";
import { Bell, Maximize2, Minimize2, X } from "lucide-react";
import { IoCheckmarkDone } from "react-icons/io5";
import { useTheme } from "../style/theme";
import { BsArrowsAngleExpand } from "react-icons/bs";

const notifications = {
    today: [
        {
            name: "Yogesh Singh",
            action: "signed the",
            highlight: "Offer Letter",
            time: "2 hours ago",
            dashboard: "HR Dashboard",
        },
        {
            name: "Tunde Thompson",
            action: "completed his",
            highlight: "Interview Assessment",
            time: "3 hours ago",
            dashboard: "HR Dashboard",
            updates: 2,
        },
    ],
    yesterday: [
        {
            name: "Rashid Ahmed",
            action: "mentioned you in a comment",
            time: "1 day ago",
            dashboard: "HR Dashboard",
            comment:
                "[media] @admin user management file design template needed as ref.",
            mentions: 4,
        },
    ],
    older: [
        {
            name: "Sandra Khan",
            action: "completed the",
            highlight: "Update website content",
            time: "3 days ago",
            dashboard: "HR Dashboard",
        },
        {
            name: "Grace Tom",
            action: "sent you a message",
            highlight: "Team Chat",
            time: "3 days ago",
            dashboard: "Clickle Chat",
        },
        {
            name: "Daniel Walter",
            action: "signed the",
            highlight: "Agreement Letter",
            time: "4 days ago",
            dashboard: "HR Dashboard",
        },
    ],
};

const NotificationDrawer = ({ open, onClose }) => {
    const [tab, setTab] = React.useState(0);
    const { mode } = useTheme();
    const [fullScreen, setFullScreen] = React.useState(false);


    const tabCounts = {
        all:
            notifications.today.length +
            notifications.yesterday.length +
            notifications.older.length,
        activities: 3,
        updates: 5,
    };

    const tabLabels = [
        { label: "All", count: tabCounts.all },
        { label: "Activities", count: tabCounts.activities },
        { label: "Updates", count: tabCounts.updates },
    ];

    return (
        <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          className: `${fullScreen ? "w-screen" : "w-[400px] max-w-full"}`,
        }}
      >      
            <div className={`${mode == "dark" ? "bg-[#141414]" : "bg-white"} p-4 h-screen overflow-y-auto`}>
                <div className="flex items-center justify-between mb-2 w-full">
                    <h2 className="text-lg font-semibold">Notifications</h2>
                    <div className="flex items-center gap-2">
                        <button style={{ border: mode == 'dark' ? '' : "1px solid #484848" }} className={`${mode == 'ligth' ? 'text-[#484848]' : ""} rounded-lg text-[12px] flex items-center gap-2 px-2 py-1 font-[600]`}>
                            <IoCheckmarkDone size={14} />
                            <span className={`${mode == 'dark' ? '' : "text-[#484848]"}`}>
                                Mark all as read
                            </span>
                        </button>
                        <IconButton onClick={() => setFullScreen(!fullScreen)}>
                            {fullScreen == true ? <Minimize2 size={14} /> : <Maximize2 size={14} />}
                        </IconButton>
                        <button onClick={onClose}>
                            <X size={20} />
                        </button>
                    </div>
                </div>

                <Box className="border-b border-gray-300">
                    <Tabs
                        value={tab}
                        onChange={(e, v) => setTab(v)}
                        TabIndicatorProps={{ className: "!bg-[#0080FF] h-1 w-full" }}
                    >
                        {tabLabels.map((t, i) => (
                            <Tab
                                key={i}
                                className="min-w-[0]"
                                label={
                                    <div className="flex items-center gap-2 mb-[-10px]">
                                        <span className={`${tab == i ? 'text-[#0080FF] text-[14px]' : 'text-[14px] text-[#A5A5A5]'}`}>{t.label}</span>
                                        <span
                                            className={`text-[10px] px-1.5 py-0.5 rounded-[3px] font-medium ${tab == i
                                                ? "bg-[#0080FF] text-white"
                                                : mode == 'dark' ? "bg-[#191919] text-[#A5A5A5]" : 'bg-[#F3F3F3] text-[#A5A5A5]'
                                            }
                                                }`}
                                        >
                                            {t.count}
                                        </span>
                                    </div>
                                }
                            />
                        ))}
                    </Tabs>
                </Box>

                <div className="mt-4 space-y-6">
                    {Object.entries(notifications).map(([section, items]) => (
                        <div key={section}>
                            <h4 className="text-sm text-gray-500 uppercase">
                                {section}
                            </h4>
                            <div className="mt-2 space-y-4">
                                {items.map((item, i) => (
                                    <div key={i} className="flex items-start gap-3">
                                        <Avatar className="w-10 h-10">{item.name[0]}</Avatar>
                                        <div className="flex-1">
                                            <p className="text-sm">
                                                <span>{item.name}</span> {item.action}{" "}
                                                {item.highlight && (
                                                    <span className="text-[#0080FF] cursor-pointer hover:underline">
                                                        {item.highlight}
                                                    </span>
                                                )}
                                            </p>
                                            {item.comment && (
                                                <div style={{border:mode == 'dark' ? '' : "1px solid #BBBBBB"}} className="text-xs p-2 mt-1 rounded">
                                                    {item.comment}
                                                </div>
                                            )}
                                            <div className="text-xs text-gray-500 flex gap-2 mt-1">
                                                <span>{item.time}</span>
                                                <span className="text-[#0080FF] cursor-pointer hover:underline">
                                                    {item.dashboard}
                                                </span>
                                            </div>
                                            {item.updates && fullScreen && (
                                                <div className="flex items-center gap-3">
                                                    <Avatar className="w-7 h-7">{item.name[0]}</Avatar>
                                                    <p className="text-xs text-[#0080FF] mt-1 cursor-pointer hover:underline">
                                                        + {item.updates} updates from {item.name.split(" ")[0]}
                                                    </p>
                                                </div>
                                            )}
                                            {item.mentions && (
                                                <p className="text-xs text-[#0080FF] mt-1 cursor-pointer hover:underline">
                                                    + {item.mentions} mentions from {item.name.split(" ")[0]}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Drawer>
    );
};

export default NotificationDrawer;
